var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEguideImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6635",
    "data-name": "Group 6635",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264.776,
    height: 166.874,
    viewBox: "0 0 264.776 166.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3075",
    "data-name": "Rectangle 3075",
    width: 264.776,
    height: 166.874,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M133.829,49.691l5.035-7.137a2.127,2.127,0,0,0-.512-2.964l-3.988-2.813a19.042,19.042,0,0,0,.435-1.945l4.8-.837a2.126,2.126,0,0,0,1.73-2.46l-1.458-8.362a2.127,2.127,0,0,0-2.461-1.73l-4.808.839q-.465-.822-1.014-1.6l2.813-3.989a2.126,2.126,0,0,0-.512-2.964L126.95,8.834a2.127,2.127,0,0,0-2.964.512l-2.807,3.979a18.961,18.961,0,0,0-2.29-.493l-.927-4.793a2.127,2.127,0,0,0-2.492-1.684l-8.333,1.612a2.127,2.127,0,0,0-1.684,2.492l.925,4.78q-.694.408-1.355.877l-3.979-2.807a2.126,2.126,0,0,0-2.964.512l-4.893,6.935A2.126,2.126,0,0,0,93.7,23.72l3.988,2.814a18.971,18.971,0,0,0-.51,2.426l-5.019,1a2.127,2.127,0,0,0-1.678,2.461L92,40.894A2.127,2.127,0,0,0,94.51,42.6l5.253-1.047q.333.547.7,1.074L97.3,47.115a2.127,2.127,0,0,0,.512,2.964l6.936,4.893a2.126,2.126,0,0,0,2.964-.512l3.157-4.476q.9.251,1.8.413l.923,5.263a2.127,2.127,0,0,0,2.5,1.72l8.455-1.65a2.127,2.127,0,0,0,1.687-2.455l-.881-5.026q.743-.418,1.453-.9l4.052,2.858a2.126,2.126,0,0,0,2.964-.512",
    transform: "translate(-37.827 -2.641)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M135.562,48.193a14.765,14.765,0,1,1-3.553-20.575,14.764,14.764,0,0,1,3.553,20.575",
    transform: "translate(-45.474 -10.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13368",
    "data-name": "Path 13368",
    d: "M0,255.324H0A12.927,12.927,0,0,1,12.926,242.4H251.85a12.926,12.926,0,1,1,0,25.853H12.926A12.927,12.927,0,0,1,0,255.324",
    transform: "translate(0 -101.377)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M61.859,137.07H26.066a8.253,8.253,0,0,1,9.613-8.133,11.27,11.27,0,0,1,20.941,2.038,6.166,6.166,0,0,1,5.238,6.095",
    transform: "translate(-10.901 -51.319)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M298.431,98.432H362.68A10.157,10.157,0,0,0,353.5,92.62c-.131,0-.259,0-.387.01a11.912,11.912,0,0,0-9.772-5.083,11.451,11.451,0,0,0-1.589.106,16.938,16.938,0,0,0-31.228-.1c-.069,0-.138,0-.208,0a11.929,11.929,0,0,0-11.883,10.884",
    transform: "translate(-124.811 -32.299)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M262.117,10.975H234.768a6.3,6.3,0,0,1,6.3-6.3,6.235,6.235,0,0,1,1.045.086,8.611,8.611,0,0,1,16,1.557,4.712,4.712,0,0,1,4,4.657",
    transform: "translate(-98.186 0)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M148.529,158.252l86.659-4.612a4.2,4.2,0,0,0,3.968-4.415L233.085,35.168a4.2,4.2,0,0,0-4.414-3.968l-86.659,4.613a9.8,9.8,0,0,0-9.266,10.308l5.475,102.866a9.8,9.8,0,0,0,10.308,9.266",
    transform: "translate(-55.512 -13.046)",
    fill: "#7da7d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3070",
    "data-name": "Rectangle 3070",
    width: 85.707,
    height: 104.276,
    transform: "matrix(0.999, -0.053, 0.053, 0.999, 83.351, 30.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3071",
    "data-name": "Rectangle 3071",
    width: 85.707,
    height: 104.276,
    transform: "translate(86.144 29.941) rotate(-3.047)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3072",
    "data-name": "Rectangle 3072",
    width: 85.707,
    height: 104.276,
    transform: "translate(89.43 29.976) rotate(-3.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M181.023,164.278l83.235-11.946a4.067,4.067,0,0,0,3.448-4.6L251.982,38.179a4.066,4.066,0,0,0-4.6-3.448L164.145,46.677a9.5,9.5,0,0,0-8.051,10.749l14.18,98.8a9.5,9.5,0,0,0,10.749,8.051",
    transform: "translate(-65.242 -14.508)",
    fill: "#4a88c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13374",
    "data-name": "Path 13374",
    d: "M323.385,186.589a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-135.234 -76.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M326.862,207.735a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-136.688 -85.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M308.49,81.75a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-129.005 -32.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M305.455,60.6a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-127.735 -23.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13378",
    "data-name": "Path 13378",
    d: "M238.271,92.745l-42.7,6.69a11.318,11.318,0,1,1-3.5-22.363l42.7-6.69a11.318,11.318,0,1,1,3.5,22.363",
    transform: "translate(-76.325 -29.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13379",
    "data-name": "Path 13379",
    d: "M213.774,94.327l1.516-.237a1.662,1.662,0,0,1,1.9,1.384l.574,3.666a11.5,11.5,0,0,1-1.788.743,12.232,12.232,0,0,1-1.762.409,4.563,4.563,0,0,1-3.753-.808,5.735,5.735,0,0,1-1.835-3.719,5.223,5.223,0,0,1,.813-4.088,5.452,5.452,0,0,1,3.715-2,7.659,7.659,0,0,1,2.126-.037.932.932,0,1,1-.254,1.847,5.139,5.139,0,0,0-1.6,0,2.915,2.915,0,0,0-2.107,1.3,3.714,3.714,0,0,0-.449,2.674,4.137,4.137,0,0,0,1.082,2.439,2.392,2.392,0,0,0,2.123.568,7.111,7.111,0,0,0,1.358-.356l-.335-2.136-1.036.162a.914.914,0,1,1-.283-1.806",
    transform: "translate(-87.212 -37.465)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M233.265,86.554a1.1,1.1,0,0,1,1.251.912l.869,5.543a3.873,3.873,0,0,1-.2,2.069,3.35,3.35,0,0,1-1.262,1.539,5.31,5.31,0,0,1-2.2.81A4.4,4.4,0,0,1,228.5,96.9a3.633,3.633,0,0,1-1.526-2.6l-.864-5.515a1.095,1.095,0,1,1,2.164-.339l.813,5.185a2.655,2.655,0,0,0,.748,1.662,2,2,0,0,0,1.662.306,1.958,1.958,0,0,0,1.457-.8,2.67,2.67,0,0,0,.206-1.823l-.81-5.171a1.1,1.1,0,0,1,.912-1.251",
    transform: "translate(-94.561 -36.194)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13381",
    "data-name": "Path 13381",
    d: "M246.132,94.618l-1.264-8.067a1.1,1.1,0,0,1,2.171-.34l1.264,8.067a1.1,1.1,0,0,1-2.171.34",
    transform: "translate(-102.404 -35.667)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13382",
    "data-name": "Path 13382",
    d: "M262.027,87.572a5.1,5.1,0,0,1-.833,4.1,5.94,5.94,0,0,1-3.946,2l-2.9.454-1.6-10.237,3.214-.5a5.481,5.481,0,0,1,4.1.713,4.929,4.929,0,0,1,1.966,3.48m-2.246.41q-.517-3.3-3.43-2.842l-1.156.181,1.045,6.667.931-.145q3.137-.492,2.609-3.86",
    transform: "translate(-105.705 -34.828)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M277.6,90.341l-5.007.784-1.6-10.237L276,80.1a.9.9,0,1,1,.279,1.778l-2.836.444.352,2.248,2.577-.4a.9.9,0,0,1,.279,1.778l-2.577.4.413,2.64,2.836-.444a.9.9,0,0,1,1.029.75l0,.014a.9.9,0,0,1-.75,1.029",
    transform: "translate(-113.336 -33.497)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13384",
    "data-name": "Path 13384",
    d: "M196.231,102.948l-5.007.784-1.6-10.238,5.007-.785a.9.9,0,0,1,.279,1.778l-2.836.444.352,2.248,2.577-.4a.9.9,0,1,1,.279,1.778l-2.577.4.413,2.64,2.836-.444a.9.9,0,0,1,1.029.75l0,.014a.9.9,0,0,1-.75,1.029",
    transform: "translate(-79.304 -38.769)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13385",
    "data-name": "Path 13385",
    d: "M310.268,61.368a.73.73,0,0,1-.1-1.452l12.044-1.728a.73.73,0,1,1,.207,1.445l-12.044,1.728a.713.713,0,0,1-.1.008",
    transform: "translate(-129.457 -24.332)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13386",
    "data-name": "Path 13386",
    d: "M313.3,82.515a.73.73,0,0,1-.1-1.452l12.044-1.728a.73.73,0,1,1,.207,1.445l-12.044,1.728a.715.715,0,0,1-.1.008",
    transform: "translate(-130.726 -33.177)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13387",
    "data-name": "Path 13387",
    d: "M312.29,102.12a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-130.594 -41.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13388",
    "data-name": "Path 13388",
    d: "M317.1,102.884a.73.73,0,0,1-.1-1.452L329.045,99.7a.73.73,0,0,1,.207,1.445l-12.044,1.728a.716.716,0,0,1-.1.008",
    transform: "translate(-132.316 -41.695)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13389",
    "data-name": "Path 13389",
    d: "M328.2,187.353a.73.73,0,0,1-.1-1.452l12.044-1.728a.73.73,0,1,1,.207,1.445L328.3,187.346a.716.716,0,0,1-.1.008",
    transform: "translate(-136.955 -77.022)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13390",
    "data-name": "Path 13390",
    d: "M320.134,165.564a3.124,3.124,0,1,0,2.648-3.536,3.124,3.124,0,0,0-2.648,3.536",
    transform: "translate(-133.875 -67.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13391",
    "data-name": "Path 13391",
    d: "M324.947,166.328a.73.73,0,0,1-.1-1.452l12.044-1.728a.73.73,0,1,1,.207,1.445l-12.044,1.728a.716.716,0,0,1-.1.008",
    transform: "translate(-135.596 -68.229)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13392",
    "data-name": "Path 13392",
    d: "M331.232,208.5a.73.73,0,0,1-.1-1.452l12.044-1.728a.73.73,0,0,1,.207,1.445l-12.044,1.728a.714.714,0,0,1-.1.008",
    transform: "translate(-138.225 -85.866)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13393",
    "data-name": "Path 13393",
    d: "M72.938,91.194a3.3,3.3,0,0,1,.588-2.756,3.738,3.738,0,0,1,5.139-.682c.967.7,1.378,1.913,2.189,2.758a5.466,5.466,0,0,0,2.288,1.006c1.827.633,3.832,1.637,4.7,3.471.725,1.54.765,4.175-1.2,4.79a2.711,2.711,0,0,1-2.806-1.251c-.635-.9-.521-2.153-1.307-2.975a2.963,2.963,0,0,0-1.312-.747,4.646,4.646,0,0,0-4.75,1.411c-.778.916-1.3,2.22-2.464,2.53A1.988,1.988,0,0,1,71.6,96.677c.1-1.091.953-2.008,1.468-2.925a5.818,5.818,0,0,0,.33-.677c.24-.6-.168-1.065-.369-1.593a2.847,2.847,0,0,1-.092-.287",
    transform: "translate(-29.942 -36.4)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13394",
    "data-name": "Path 13394",
    d: "M127.2,257.178h-5.79a9.8,9.8,0,0,1-5-1.692c-1.191-.738-2.982-2.225-4.441-1.33a6.95,6.95,0,0,0-2,2.391,1.323,1.323,0,0,1-1.127.631h-.3a1.861,1.861,0,0,1-1.858-1.968l.478-8.223,11.688-1.543c4.488,2.778,7,7.074,8.35,11.734",
    transform: "translate(-44.616 -102.651)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13395",
    "data-name": "Path 13395",
    d: "M42.686,257.178h5.79a9.8,9.8,0,0,0,5-1.692c1.191-.738,2.982-2.225,4.441-1.33a6.95,6.95,0,0,1,2,2.391,1.323,1.323,0,0,0,1.127.631h.3A1.86,1.86,0,0,0,63.2,255.21l-.478-8.223-11.688-1.543c-4.488,2.778-7,7.074-8.35,11.734",
    transform: "translate(-17.852 -102.651)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13396",
    "data-name": "Path 13396",
    d: "M56.851,210.836,64.689,169.1a6.03,6.03,0,1,1,11.852,2.226L68.7,213.062c-.544,2.9-12.466,1.047-11.852-2.226",
    transform: "translate(-23.767 -68.665)",
    fill: "#285ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13397",
    "data-name": "Path 13397",
    d: "M99.9,214.96,89.309,175.552a6.029,6.029,0,1,1,11.645-3.131l10.594,39.409c.865,3.215-10.922,5.822-11.645,3.131",
    transform: "translate(-37.264 -70.243)",
    fill: "#285ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13398",
    "data-name": "Path 13398",
    d: "M90.6,156.849a49.388,49.388,0,0,1-28.083,0c-.533-.154-.137-6.877-.083-7.692a36.625,36.625,0,0,1,1.24-7.251c1.708-6.242,5.134-12.323,12.455-12.323,5.94,0,9.584,4.228,11.508,9.445a52.2,52.2,0,0,1,2.232,8.105c.195,1.01,1.51,9.488.731,9.715",
    transform: "translate(-26.029 -54.195)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13399",
    "data-name": "Path 13399",
    d: "M77.039,126.3h9.749l1,5.628H76.042Z",
    transform: "translate(-31.803 -52.822)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13400",
    "data-name": "Path 13400",
    d: "M109.959,177.524a.464.464,0,0,1-.047-.926c1.645-.169,6.015-.617,6.994-2a.876.876,0,0,0,.144-.759,1.08,1.08,0,0,0-1.3-.8l-2.655.635a.465.465,0,0,1-.568-.514c.008-.056.015-.112.02-.169a.463.463,0,0,1,.355-.408l3.928-.94a1.081,1.081,0,1,0-.5-2.1l-3.951.944a.464.464,0,0,1-.5-.2l-.018-.028-.04-.061a.465.465,0,0,1,.274-.715l1.442-.344a1.085,1.085,0,0,0,.652-.509,1.115,1.115,0,0,0,.148-.841c-.118-.459-.431-.858-1.911-.671-.471.059-1.036.116-1.634.176-.9.091-1.91.192-2.967.336a.464.464,0,0,1-.125-.92c1.073-.146,2.1-.248,3-.34.618-.062,1.152-.116,1.611-.173.618-.078,2.5-.315,2.927,1.361a2.015,2.015,0,0,1-.13,1.318l1-.24a2.009,2.009,0,0,1,1.114,3.857,1.991,1.991,0,0,1,.731,1.127,1.818,1.818,0,0,1-.29,1.513c-1.077,1.519-4.475,2.057-7.657,2.385l-.048,0",
    transform: "translate(-44.874 -69.486)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13401",
    "data-name": "Path 13401",
    d: "M149.751,126.518a.464.464,0,0,1-.3-.817c1.258-1.073,4.6-3.922,4.624-5.615a.878.878,0,0,0-.312-.707,1.081,1.081,0,0,0-1.527.081l-1.825,2.029a.465.465,0,0,1-.759-.1c-.026-.051-.051-.1-.079-.15a.464.464,0,0,1,.06-.538l2.7-3a1.082,1.082,0,0,0-.08-1.527,1.082,1.082,0,0,0-1.526.081l-2.717,3.021a.465.465,0,0,1-.522.119l-.023-.009c-.024-.011-.049-.02-.074-.03a.464.464,0,0,1-.18-.745l.992-1.1a1.082,1.082,0,0,0,.248-.789,1.118,1.118,0,0,0-.355-.776c-.357-.311-.841-.461-1.954.532-.354.316-.787.684-1.245,1.073-.686.582-1.464,1.242-2.253,1.96a.464.464,0,0,1-.625-.686c.8-.73,1.585-1.4,2.277-1.982.474-.4.883-.749,1.228-1.057.464-.415,1.877-1.677,3.182-.54a2.011,2.011,0,0,1,.641,1.158l.69-.767a2.009,2.009,0,0,1,3.106,2.544,1.989,1.989,0,0,1,1.242.513,1.816,1.816,0,0,1,.62,1.41c-.025,1.863-2.516,4.235-4.95,6.309a.462.462,0,0,1-.3.111",
    transform: "translate(-59.332 -48.003)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13402",
    "data-name": "Path 13402",
    d: "M99.879,142.6a30.651,30.651,0,0,1-15.615-4.268l4.765-8.079a21.31,21.31,0,0,0,23.842-1.417l1.161-.886a4.69,4.69,0,1,1,5.689,7.458l-1.161.886a30.667,30.667,0,0,1-16.838,6.251q-.922.055-1.843.055",
    transform: "translate(-35.241 -53.11)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13403",
    "data-name": "Path 13403",
    d: "M67.642,168.017a16.064,16.064,0,0,1-11.418-4.137A14.789,14.789,0,0,1,52.2,150.029c1.1-4.946,4.367-9.415,9.99-13.662a4.69,4.69,0,1,1,5.653,7.484c-3.717,2.808-5.9,5.571-6.487,8.214a5.44,5.44,0,0,0,1.354,5.043c2.593,2.485,8.629,1.585,13.139-.3a4.69,4.69,0,0,1,3.621,8.653,32.77,32.77,0,0,1-11,2.544q-.42.015-.833.015",
    transform: "translate(-21.68 -56.635)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13404",
    "data-name": "Path 13404",
    d: "M76.464,190.277a21.373,21.373,0,0,1-3.137-.226.464.464,0,1,1,.137-.919,20.4,20.4,0,0,0,3,.216c.267,0,.542-.005.816-.015a31.193,31.193,0,0,0,8.915-1.774.464.464,0,1,1,.306.877,32.155,32.155,0,0,1-9.187,1.826c-.285.01-.571.015-.849.015",
    transform: "translate(-30.502 -78.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13405",
    "data-name": "Path 13405",
    d: "M83.936,174.43a.464.464,0,0,1-.153-.9c.659-.23,1.3-.477,1.92-.735a4.225,4.225,0,0,0-3.262-7.8c-4.645,1.944-10.9,2.838-13.639.209a5.908,5.908,0,0,1-1.486-5.479,12.149,12.149,0,0,1,3.362-5.6.465.465,0,1,1,.669.645,11.262,11.262,0,0,0-3.125,5.16,4.966,4.966,0,0,0,1.222,4.607c2.333,2.236,8.124,1.494,12.638-.4a5.154,5.154,0,0,1,3.979,9.509c-.633.265-1.3.519-1.973.755a.458.458,0,0,1-.153.026",
    transform: "translate(-28.09 -64.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13406",
    "data-name": "Path 13406",
    d: "M86.751,102.448a3.365,3.365,0,0,0-.387-.214,7.474,7.474,0,0,1-1.968-1.365,5.251,5.251,0,0,0-3.62-1.44,6.067,6.067,0,0,0-3.4,1.244,12.2,12.2,0,0,1-2.48,1.472,3.235,3.235,0,0,0-.618.316A2.711,2.711,0,0,0,73.4,106.1a2.642,2.642,0,0,0,2.841,1.281,5.271,5.271,0,0,0,9.041.054,2.634,2.634,0,0,0,2.388-1.365,2.713,2.713,0,0,0-.917-3.622",
    transform: "translate(-30.543 -41.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M80.445,110.1a5.766,5.766,0,0,1-4.767-2.548A3.084,3.084,0,0,1,72.665,106a3.193,3.193,0,0,1,1.026-4.259,3.719,3.719,0,0,1,.707-.362,9.454,9.454,0,0,0,1.995-1.155l.389-.267a6.551,6.551,0,0,1,3.663-1.325,5.712,5.712,0,0,1,3.939,1.567,7.005,7.005,0,0,0,1.845,1.281,3.772,3.772,0,0,1,.443.244,3.159,3.159,0,0,1,1.071,4.239,3.073,3.073,0,0,1-2.536,1.6,5.694,5.694,0,0,1-4.762,2.539m-4.305-3.573.168.284a4.832,4.832,0,0,0,4.137,2.36,4.776,4.776,0,0,0,4.108-2.311l.14-.23.269.007a2.156,2.156,0,0,0,1.97-1.128,2.24,2.24,0,0,0-.763-3,2.76,2.76,0,0,0-.332-.183,7.941,7.941,0,0,1-2.091-1.448,4.784,4.784,0,0,0-3.3-1.314,5.7,5.7,0,0,0-3.142,1.165l-.383.263a10.316,10.316,0,0,1-2.191,1.258,2.775,2.775,0,0,0-.529.271,2.236,2.236,0,0,0-.73,3.018,2.173,2.173,0,0,0,2.347,1.058Z",
    transform: "translate(-30.213 -41.25)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13408",
    "data-name": "Path 13408",
    d: "M86.546,111.141l-.073.03a2.466,2.466,0,0,1-2.549-.432,2.3,2.3,0,0,0-3.044.038,2.406,2.406,0,0,1-2.543.414l-.036-.015a.957.957,0,0,0-1.258,1.236,5.758,5.758,0,0,0,10.77-.068.955.955,0,0,0-1.268-1.2",
    transform: "translate(-32.193 -46.08)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13409",
    "data-name": "Path 13409",
    d: "M87.489,133.04H84.867a1.382,1.382,0,0,1,0-2.764h2.623a1.382,1.382,0,1,1,0,2.764",
    transform: "translate(-34.915 -54.485)",
    fill: "#285ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13410",
    "data-name": "Path 13410",
    d: "M84.632,133.069c.811.178,1.352,11.393-1.391,19.474l3.051-3.363,3.737,1.776c.336-2.7-2.218-19.608-3.87-18.224Z",
    transform: "translate(-34.813 -55.478)",
    fill: "#285ca8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3073",
    "data-name": "Rectangle 3073",
    width: 37.003,
    height: 12.3,
    transform: "translate(154.301 137.237) rotate(-0.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3074",
    "data-name": "Rectangle 3074",
    width: 23.466,
    height: 8.476,
    transform: "translate(157.658 127.301) rotate(-0.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13411",
    "data-name": "Path 13411",
    d: "M283.949,246.443,256.2,246.7a6.609,6.609,0,0,1-.1-11.19l27.75-.257a.742.742,0,1,0-.014-1.485l-57.818.535a7.08,7.08,0,1,0,.131,14.159l57.818-.535a.742.742,0,1,0-.014-1.485",
    transform: "translate(-91.591 -97.768)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13412",
    "data-name": "Path 13412",
    d: "M275.809,225.86l-20.5.084a4.614,4.614,0,0,1-.39-6.744c.106-.11.219-.215.336-.314l20.527-.084h0a.709.709,0,0,0-.008-1.418l-45.947.189H229.8a4.947,4.947,0,0,0,.066,9.893l45.947-.189h0a.709.709,0,0,0-.008-1.418",
    transform: "translate(-94.059 -90.916)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13413",
    "data-name": "Path 13413",
    d: "M399.392,241.269H388.933A7.931,7.931,0,0,1,381,233.338V208.052h26.321v25.286a7.931,7.931,0,0,1-7.931,7.931",
    transform: "translate(-159.344 -87.013)",
    fill: "#b8d4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13414",
    "data-name": "Path 13414",
    d: "M388.791,234.152H378.332a8.4,8.4,0,0,1-8.4-8.4V200.47a.464.464,0,0,1,.464-.464h26.321a.464.464,0,0,1,.464.464v25.286a8.4,8.4,0,0,1-8.4,8.4m-17.926-33.217v24.822a7.475,7.475,0,0,0,7.467,7.466h10.459a7.475,7.475,0,0,0,7.466-7.466V200.935Z",
    transform: "translate(-154.717 -83.647)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13415",
    "data-name": "Path 13415",
    d: "M384,145.333H365.99a3.463,3.463,0,0,1,0-6.927H384a3.463,3.463,0,1,1,0,6.927",
    transform: "translate(-151.618 -57.885)",
    fill: "#7da7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13416",
    "data-name": "Path 13416",
    d: "M393.431,167.5H375.422a3.463,3.463,0,0,1,0-6.927h18.009a3.463,3.463,0,0,1,0,6.927",
    transform: "translate(-155.562 -67.157)",
    fill: "#7da7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13417",
    "data-name": "Path 13417",
    d: "M384.643,156.168a3.463,3.463,0,0,1-3.463-3.463V141.869a3.463,3.463,0,1,1,6.927,0V152.7a3.463,3.463,0,0,1-3.463,3.463",
    transform: "translate(-159.419 -57.885)",
    fill: "#7da7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13418",
    "data-name": "Path 13418",
    d: "M396.945,176.74a3.463,3.463,0,0,1-3.463-3.463V163.9a3.463,3.463,0,0,1,6.927,0v9.382a3.463,3.463,0,0,1-3.463,3.463",
    transform: "translate(-164.564 -67.097)",
    fill: "#7da7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13419",
    "data-name": "Path 13419",
    d: "M175.775,215.979H160.447a.8.8,0,0,1-.441-.132,52.542,52.542,0,0,1-4.819-3.479c-.871-.725-2.89-2.628-2.828-4.625a3.053,3.053,0,0,1,1.386-2.418,4.334,4.334,0,0,1,2.823-.791,5.413,5.413,0,0,1,1.1.2c-.624-2.162-.936-5.622.632-7.283.653-.692,1.883-1.336,4.032-.474,2.51,1.006,4.381,3.4,5.559,7.106q.169.533.318,1.1c.344-1.721.755-3.431,1.226-5.105a39.574,39.574,0,0,1,2.611-7.094c.816-1.636,2.14-3.7,3.818-4.224a2.033,2.033,0,0,1,2.043.326c1.106.949,1.332,3.293.71,7.376-.354,2.342-.9,4.623-1.159,5.72-.049.208-.089.374-.115.489-.232,1.03-.481,2.037-.744,3a11.162,11.162,0,0,1,1.765-.453,6.588,6.588,0,0,1,2.021-.049,4.322,4.322,0,0,1,1,.262,2.22,2.22,0,0,1,1.456,1.558c.276,1.164-.375,2.619-1.989,4.444a36.612,36.612,0,0,1-4.585,4.368.8.8,0,0,1-.5.175m-15.291-.929h15.247a35.769,35.769,0,0,0,4.433-4.229c1.72-1.945,1.918-3.04,1.781-3.616a1.323,1.323,0,0,0-.9-.91,3.4,3.4,0,0,0-.789-.2,5.658,5.658,0,0,0-1.733.045,10.585,10.585,0,0,0-2.434.732.465.465,0,0,1-.631-.555c.351-1.218.681-2.513.981-3.849.027-.118.067-.287.118-.5.258-1.085.8-3.341,1.145-5.644.689-4.527.164-6.051-.4-6.532a1.144,1.144,0,0,0-1.161-.145c-1.051.33-2.24,1.7-3.265,3.752a38.718,38.718,0,0,0-2.548,6.93,67.673,67.673,0,0,0-1.627,7.325.464.464,0,0,1-.458.389h0a.464.464,0,0,1-.458-.387,23.9,23.9,0,0,0-.78-3.292c-1.091-3.432-2.78-5.628-5.02-6.525-1.317-.528-2.359-.442-3.011.249-1.449,1.535-.858,5.475-.12,7.25a.464.464,0,0,1-.625.6,4.876,4.876,0,0,0-1.731-.473,3.384,3.384,0,0,0-2.208.615,2.141,2.141,0,0,0-1.006,1.7c-.051,1.633,1.9,3.384,2.495,3.882a51.4,51.4,0,0,0,4.7,3.4",
    transform: "translate(-63.72 -78.888)",
    fill: "#0c0f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13420",
    "data-name": "Path 13420",
    d: "M178.307,251.062h-9.913a.8.8,0,0,1-.789-.663L164.9,234.986a.8.8,0,0,1,.789-.941h7.449a.734.734,0,0,1,.087.005.717.717,0,0,1,.087-.005h7.706a.8.8,0,0,1,.79.94L179.1,250.4a.8.8,0,0,1-.789.663m-9.807-.928h9.7l2.663-15.159h-7.539a.468.468,0,0,1-.2,0h-7.283Z",
    transform: "translate(-68.959 -97.883)",
    fill: "#0c0f1e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEguideImg);
export default __webpack_public_path__ + "static/media/eguide-img.22233b0d0138a4f3f491052f3ce6d65c.svg";
export { ForwardRef as ReactComponent };